import { render, staticRenderFns } from "./CheckoutHeader.vue?vue&type=template&id=1876c53c&"
import script from "./CheckoutHeader.vue?vue&type=script&lang=js&"
export * from "./CheckoutHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports